import { Component, Input, OnInit } from '@angular/core';

import { NbMenuService, NbSidebarService, NbToastrService } from '@nebular/theme';
import { UserService } from '../../../@core/data/users.service';
import { AnalyticsService } from '../../../@core/utils/analytics.service';
import { LayoutService } from '../../../@core/data/layout.service';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { filter, map } from 'rxjs/operators';
import { ApiService } from '@services/api/api.service';
import { Router } from '@angular/router';
import { NotificationsService } from '@services/notifications/notifications.service';
import { BreadCrumbsService } from '../../../services/NewFolder/bread-crumbs.service';

@Component({
  selector: 'ngx-header',
  styleUrls: ['./header.component.scss'],
  templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {

  @Input() position = 'normal';

  user: any;

  userMenu = [{ title: 'Profile' }, { title: 'Log out' }];
  searchString: string;
  suggestions: any;
  constructor(private sidebarService: NbSidebarService,
    private menuService: NbMenuService,
    private userService: UserService,
    private analyticsService: AnalyticsService,
    private layoutService: LayoutService,
    public auth: IdentityAuthService,
    private nbMenuService: NbMenuService,
    private apiService: ApiService,
    private router: Router,
    private messageService: NbToastrService,
    public notificationsService: NotificationsService,
    public breadCrumbService: BreadCrumbsService) {
  }

  ngOnInit() {
    this.nbMenuService.onItemClick()
      .pipe(
        filter(({ tag }) => tag === 'user-context-menu'),
        map(({ item: { title } }) => title),
      )
      .subscribe(title => {
        if (title == "Log out")
          this.logOut();
        else if (title == "Profile")
          this.profileClicked();
      });
  }

  toggleSidebar(): boolean {
    this.sidebarService.toggle(true, 'menu-sidebar');
    this.layoutService.changeLayoutSize();

    return false;
  }

  toggleSettings(): boolean {
    this.sidebarService.toggle(false, 'settings-sidebar');

    return false;
  }

  goToHome() {
    this.menuService.navigateHome();
  }

  startSearch() {
    this.analyticsService.trackEvent('startSearch');
  }

  profileClicked() {
    this.router.navigate(["/party/profile"]);
  }

  logOut() {
    this.auth.logoff();
  }

  search(event) {
    this.searchString = event.query;
    //this.loading = true;

    this.apiService.get(`/api/stockItem/globalSearch/${this.searchString}`)
      .subscribe(stockItems => {
        this.suggestions = new Array();
        this.suggestions = stockItems;
      }, err => {

      });
  }

  suggestionSelected(value) {
    this.searchString = "";
    this.router.navigate(['/stock/list', { id_1: value.id }]);
    this.messageService.success('Navigated to item', "Action");
  }

  navigateHome() {
    this.router.navigate(['/']);
  }

}
